import { trackEvent } from '../../support-and-tracking/analytics-actions';
import { resendActivationCode } from '../../user/user-actions';
import { connect } from 'react-redux';
import { Title } from '../typography/Heading';
import { useIsUserEmailActivated } from '../hooks/isUserEmailActivated';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import styles from './activate-email.module.less';

const ActivateEmail = ({ user = {}, isSendingActivationCode = false, resendActivationCode, infoText }) => {
    const { initialActivationStatus, isUserActivated } = useIsUserEmailActivated();

    const onClick = () => {
        resendActivationCode();
        trackEvent('activation-code', 'resend', {});
    };

    if (isUserActivated && initialActivationStatus) {
        return null;
    }

    if (!user) {
        return null;
    }

    return (
        <>
            <Title tag={'h2'}>Aktiver kontoen din</Title>
            <div className={styles.activateEmailContainer}>
                {isUserActivated ? (
                    <p>Kontoen din er nå aktivert 🎉</p>
                ) : (
                    <>
                        {infoText && <p>infoText</p>}
                        <p>
                            Vi har sendt deg aktiveringslenken på e-post til <strong>{user.email}</strong>.
                        </p>
                        <RoundedButtonPrimary disabled={isSendingActivationCode} onClick={onClick}>
                            {isSendingActivationCode ? 'Sender e-posten …' : 'Send e-posten på nytt'}
                        </RoundedButtonPrimary>
                    </>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        isSendingActivationCode: state.user.isSendingActivationCode,
    };
};

const mapDispatchToProps = (dispatch, props) => ({
    resendActivationCode: () => {
        dispatch(resendActivationCode(props.user));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivateEmail);
